/*
 * @Author: liukai
 * @since: 2022-04-13 14:44:14
 * @LastAuthor: liukai
 * @lastTime: 2022-04-22 14:44:01
 */
import { createRouter,
  //  createWebHashHistory,
   createWebHistory 
   } from "vue-router";

const routes = [
  
  
  {
    name: "home",
    path: "/",
    component: () => import("./view/home"),
    meta: {
      title: "首页",
    },
  },
  {
    name: "search",
    path: "/search",
    component: () => import("./view/search"),
    meta: {
      title: "河南疫情",
    },
  },
  {
    name:'country',
    path:'/country',
    component: () => import("./view/country"),
    meta: {
      title: "河南疫情",
    },
  },
  {
    name:'henan',
    path:'/henan',
    component: () => import("./view/henan"),
    meta: {
      title: "河南疫情",
    },
  },
  {
    name: "notFound",
    path: "/:path(.*)+",
    redirect: {
      name: "home",
    },
  },
];
const router = createRouter({
  routes,
  // history: createWebHashHistory(),
  history:createWebHistory(process.env.VUE_APP_BASE_URL),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
